import {req, reqPost} from './axiosFun';
const BASE_URL="";
/**
 * 实时收入
 **/
// 实时收入分页查询
export const queryRevenueFlowPage = (params) => { return reqPost(BASE_URL+"/api/revenueFlow/queryRevenueFlowPage", params) };
// 补账功能
export const addRevenueFlowPage= (params) => { return reqPost(BASE_URL+"/api/revenueFlow/saveOrUpdateRevenueFlow", params) };
// 除账
export const deleteRevenue= (params) => { return reqPost(BASE_URL+"/api/revenueFlow/delete", { ids: params }) };

/**
 * 实时支出
 **/
// 实时支出分页查询
export const queryExpenditureFlowPage= (params) => { return reqPost(BASE_URL+"/api/expenditureFlow/queryExpenditureFlowPage", params) };
// 添加或保存实时支出
export const addOrUpdateExpenditureFlow=(params) => { return reqPost(BASE_URL+"/api/expenditureFlow/saveOrUpdateExpenditureFlow", params) };
// 批量删除支出流水
export const deleteExpenditureFlow= (params) => { return reqPost(BASE_URL+"/api/expenditureFlow/delete", { ids: params }) };


/**
 * 充电桩记账（纯记录，不计入收支和余额）
 */
export const queryChargingPage = (params) => { return reqPost(BASE_URL+"/api/charging/page", params) };
export const saveCharging = (params) => { return reqPost(BASE_URL+"/api/charging/save", params) };
export const deleteCharging = (ids) => { return reqPost(BASE_URL+"/api/charging/delete", { ids }) };



// WEBPACK FOOTER //
// ./src/api/realTimeBill.js